"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShouldResetCache = void 0;
const cache_notifications_1 = require("./cache-notifications");
const dispatch_custom_event_1 = require("./dispatch-custom-event");
function isPromiseLike(obj) {
    return typeof (obj === null || obj === void 0 ? void 0 : obj.then) === 'function' && typeof (obj === null || obj === void 0 ? void 0 : obj.finally) === 'function';
}
function ShouldResetCache(target, propertyKey, descriptor) {
    if (!descriptor || typeof descriptor.value !== 'function') {
        throw new TypeError(`Only methods can be decorated with @ShouldResetCache. <${propertyKey}> is not a method!`);
    }
    if (typeof descriptor.get === 'function') {
        throw new TypeError(`Only methods can be decorated with @ShouldResetCache. <${propertyKey}> is a getter function!`);
    }
    const cacheSupportTarget = target;
    if (!cacheSupportTarget.__shouldResetCache) {
        cacheSupportTarget.__shouldResetCache = new Set();
    }
    cacheSupportTarget.__shouldResetCache.add(propertyKey);
    const originalMethod = descriptor.value;
    descriptor.value = function (...args) {
        const result = originalMethod.apply(this, args);
        if (isPromiseLike(result)) {
            return result.then((r) => {
                (0, dispatch_custom_event_1.dispatchCustomEvent)(cache_notifications_1.cacheNotifications.Crud, { detail: this });
                return r;
            });
        }
        else {
            (0, dispatch_custom_event_1.dispatchCustomEvent)(cache_notifications_1.cacheNotifications.Crud, { detail: this });
            return result;
        }
    };
    return descriptor;
}
exports.ShouldResetCache = ShouldResetCache;
//# sourceMappingURL=should-reset-cache.decorator.js.map